import React, { useEffect } from 'react';
import './MAPCompliance.css';

const MAPCompliance = () => {
    useEffect(() => {
        document.title = 'MAP Compliance | Avenis Global';
    }, []);

    return (
        <div className="map-compliance-page">
            <div className="compliance-hero">
                <div className="container">
                    <h1>MAP Compliance</h1>
                    <p>
                        Ensuring brand protection and fair pricing across all
                        e-commerce channels with enterprise-grade monitoring and
                        enforcement.
                    </p>
                </div>
            </div>

            <div className="container">
                <div className="compliance-content">
                    <div className="compliance-overview">
                        <h2>What is MAP Compliance?</h2>
                        <p>
                            Minimum Advertised Price (MAP) compliance is a
                            critical component of brand protection and pricing
                            strategy. At{' '}
                            <span className="brand-gradient">
                                Avenis Global
                            </span>
                            , we help brands and retailers maintain consistent
                            pricing across all channels while protecting brand
                            value and preventing price wars.
                        </p>
                    </div>

                    <div className="compliance-features">
                        <h2>Our MAP Compliance Solutions</h2>
                        <div className="features-grid">
                            <div className="feature-card">
                                <div className="feature-icon">🔍</div>
                                <h3>Price Monitoring</h3>
                                <p>
                                    Continuous monitoring of product prices
                                    across all major e-commerce platforms and
                                    marketplaces to ensure MAP compliance.
                                </p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">⚖️</div>
                                <h3>Policy Enforcement</h3>
                                <p>
                                    Automated enforcement of MAP policies with
                                    immediate alerts and corrective actions for
                                    non-compliant retailers.
                                </p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">📊</div>
                                <h3>Analytics & Reporting</h3>
                                <p>
                                    Comprehensive reporting on compliance rates,
                                    violator identification, and market trends
                                    to support strategic decisions.
                                </p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">🛡️</div>
                                <h3>Brand Protection</h3>
                                <p>
                                    Advanced brand protection measures including
                                    unauthorized seller detection and
                                    counterfeit product identification.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="compliance-benefits">
                        <h2>Benefits of MAP Compliance</h2>
                        <div className="benefits-list">
                            <div className="benefit-item">
                                <h4>Brand Value Protection</h4>
                                <p>
                                    Maintain consistent brand positioning and
                                    prevent devaluation through unauthorized
                                    discounting.
                                </p>
                            </div>
                            <div className="benefit-item">
                                <h4>Retailer Relationship Management</h4>
                                <p>
                                    Foster healthy relationships with authorized
                                    retailers by ensuring fair competition.
                                </p>
                            </div>
                            <div className="benefit-item">
                                <h4>Market Stability</h4>
                                <p>
                                    Prevent price wars and maintain market
                                    stability across all distribution channels.
                                </p>
                            </div>
                            <div className="benefit-item">
                                <h4>Legal Compliance</h4>
                                <p>
                                    Ensure adherence to pricing policies and
                                    legal requirements in all markets.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="compliance-process">
                        <h2>Our MAP Compliance Process</h2>
                        <div className="process-steps">
                            <div className="step">
                                <div className="step-number">1</div>
                                <div className="step-content">
                                    <h3>Policy Development</h3>
                                    <p>
                                        Work with brands to develop
                                        comprehensive MAP policies tailored to
                                        their specific market needs and legal
                                        requirements.
                                    </p>
                                </div>
                            </div>
                            <div className="step">
                                <div className="step-number">2</div>
                                <div className="step-content">
                                    <h3>Implementation</h3>
                                    <p>
                                        Deploy monitoring systems across all
                                        relevant channels and establish
                                        communication protocols with retailers.
                                    </p>
                                </div>
                            </div>
                            <div className="step">
                                <div className="step-number">3</div>
                                <div className="step-content">
                                    <h3>Monitoring & Enforcement</h3>
                                    <p>
                                        Continuous monitoring with automated
                                        alerts and systematic enforcement of MAP
                                        policies.
                                    </p>
                                </div>
                            </div>
                            <div className="step">
                                <div className="step-number">4</div>
                                <div className="step-content">
                                    <h3>Reporting & Optimization</h3>
                                    <p>
                                        Regular reporting and analysis to
                                        optimize policies and improve compliance
                                        rates.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="compliance-cta">
                        <h2>Ready to Protect Your Brand?</h2>
                        <p>
                            Contact us today to learn how our MAP compliance
                            solutions can protect your brand and ensure fair
                            pricing across all channels.
                        </p>
                        <div className="cta-buttons">
                            <a
                                href="/contact"
                                className="btn btn-primary"
                                onClick={() => window.scrollTo(0, 0)}
                            >
                                Get Started
                            </a>
                            <a
                                href="/contact"
                                className="btn btn-secondary"
                                onClick={() => window.scrollTo(0, 0)}
                            >
                                Schedule Consultation
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAPCompliance;
